import { HDComponent } from "app/hotel-directory/hotel-directory-edit/hotel-directory-edit-list"

export class HotelDirectory {
  organisationId: string
  hotelId: string
  id: string
  status: string
  unpublishedChanges: boolean
  publicToOrganisation: boolean
  isHomeDirectory: boolean
  description: string
  name: string
  createdBy: string
  lastEditedBy: string
  created: Date
  lastEdited: Date
  hotelName?: string
  languages?: string[]
  isActiveEditing: string
  isActiveEditingObject?: IsActiveEditingObject
  expanded?: boolean //Only in frontend
}

export class IsActiveEditingObject {
  email: string
  hash: string
}

export class Page {
  hotelId: string
  id: string
  pageId: string
  name: string
  lastEdited: Date
  data: Layouts[]
  dataDraft: Layouts[]
  defaultLanguage: string
  functions?: functionDictionary
  functionsDraft?: functionDictionary
  languages?: string[]
  alias?: string
}

export class ChangeLog {
  hotelId: string
  id: string
  action: string
  timestamp: string
  context: string
  description: string
}
export class ChangeLogGroup {
  date: Date
  logs: ChangeLog[]
}
export interface functionDictionary {
  [key: string]: string
}

export class Layouts {
  priority: number
  objType: string
  internalName?: string
  id?: string
  layouts?: Layouts[]
  HDBreaker?: HDBreaker
  HDButton?: HDButton
  HDButtonList?: HDButtonList
  HDCardText?: HDCardText
  HDDivider?: HDDivider
  HDIcon?: HDIcon
  HDImage?: HDImage
  HDImageWIthTitle?: HDImageWithTitle
  HDpdf?: HDpdf
  HDText?: HDText
  HDSection?: HDSection
  //Supporting inner types
  backendName?: string
  category?: string
  imageUrl?: string
  title?: string
  data?: any
  condition?: string
  conditionText?: string
  conditionMode?: string
  expanded?: boolean
}

export class HDBreaker extends Layouts {
  height: number
  id?: string
}
export class HDButton {
  text: any //Dictionary
  linkType: string
  subpageLink?: string
  link: string
  style: string
  priority: number
  objType: string
  id?: string
  buttonImage?: string
  linkSubType?: string
}
export class HDButtonList {
  buttons: HDButton[]
  priority: number
  objType: string
}
export class HDCardText {
  header?: any
  headerEnabled?: boolean = true
  subHeader?: any
  subHeaderEnabled?: boolean = true
  paragraph?: any
  paragraphEnabled?: boolean = true
  button?: HDButton
  buttonEnabled?: boolean = true
  priority: number
  objType: string
}
export class HDDivider {
  priority: number
  objType: string
  id?: string
}
export class HDIcon {
  icon: string
  link: string
  priority: number
  objType: string
  id?: string
}
export class HDImage {
  type?: "Image"
  id?: string
  imageLink: string
  imageCropping: any
  linkType: string
  subpageLink?: string
  link: string
  priority: number
  objType: string
  name?: string
  linkSubType?: string
}
export class Image_2_1 {
  type?: "Image_2_1"
  id?: string
  Image1: HDImage
  Image2: HDImage
  Image3: HDImage
}
export class Image_1_2 {
  type?: "Image_1_2"
  id?: string
  Image1: HDImage
  Image2: HDImage
  Image3: HDImage
}
export class ImageCarousel {
  type?: "Carousel"
  id?: string
  ImageList: HDImageWithTitle[] = []
}

export class HDImageWithTitle {
  title: any
  imageLink: string
  imageCropping: any
  linkType: string
  subpageLink?: string
  link: string
  priority: number
  objType: string
  id?: string
  linkSubType?: string
}
export class HDpdf {
  link: string
  priority: number
  objType: string
  elementid?: string
  id?: string
}
export class HDText {
  text: any
  priority: number
  objType: string
  id?: string
  header?: boolean
}

export class CardVerticalLargeRight {
  Card: HDCardText
  Image: HDImage
}
export class CardVerticalLargeLeft {
  Image: HDImage
  Card: HDCardText
}
export class CardVerticalMediumLeft {
  Image1: HDImage
  Card1: HDCardText
  Image2: HDImage
  Card2: HDCardText
}
export class CardVerticalMediumRight {
  Card1: HDCardText
  Image1: HDImage
  Card2: HDCardText
  Image2: HDImage
}
export class CardHorizontalLarge {
  Image1: HDImage
  Card1: HDCardText
  Image2: HDImage
  Card2: HDCardText
}
export class CardHorizontalMedium {
  Image1: HDImage
  Card1: HDCardText
  Image2: HDImage
  Card2: HDCardText
  Image3: HDImage
  Card3: HDCardText
}
export class CardHorizontalSmall {
  Image1: HDImage
  Card1: HDCardText
  Image2: HDImage
  Card2: HDCardText
  Image3: HDImage
  Card3: HDCardText
  Image4: HDImage
  Card4: HDCardText
}

export class SoMe {
  id: string
  header: HDText
  iconList: HDIcon[]
  priority: number
  objType: string
}

export class HDSection {
  Condition: string
  Layouts: Layouts[]
  id: string
}
